module.exports = __webpack_public_path__ + "static/media/3.eea3a7bc.svg";